import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { UnsavedChangesDialogService } from '../../app/shared/dialogs/unsaved-changes/unsaved-changes-dialog-service';
import { AuthService } from './auth.service';
import { NotificationDAO } from './dao/notificationDAO';
import { EnvironmentalMediaService } from './environmental-media.service';
import { AbandonedBuyflowDAO } from './dao/abandonedBuyflowDAO';

@Injectable()
export class PendingChangesGuard
  implements CanDeactivate<ComponentCanDeactivate>
{
  constructor(
    private unsavedChangesDialog: UnsavedChangesDialogService,
    private authService: AuthService,
    private abandonedBuyflowDAO: AbandonedBuyflowDAO,
    private notificationDAO: NotificationDAO,
    private environmentalMediaService: EnvironmentalMediaService,
  ) {}

  canDeactivate(
    component: ComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isMessageRequest =
      currentRoute.queryParamMap.get('messageRequest') === 'true';
    if (isMessageRequest || component.canDeactivate()) {
      return true;
    } else {
      const canLeave = new Subject<boolean>();
      this.unsavedChangesDialog.open().subscribe((response) => {
        if (response) {
          if (sessionStorage.getItem('bailBookingEmailData')) {
            const emailData = JSON.parse(
              sessionStorage.getItem('bailBookingEmailData'),
            );
            if (emailData.userId) {
              this.notificationDAO
                .abandonBuyflow(emailData.userId)
                .subscribe((res) => {
                  canLeave.next(response);
                });

              const subject = `User ${emailData.userId} Abandoned Buyflow Request`;
              let message =
                `User ${emailData.userId} has abandoned a buyflow request<br>` +
                `Boat Name: ${emailData.boat}<br>` +
                `Date: ${emailData.date}<br>` +
                `User Name: ${emailData.name}<br>` +
                `Phone Number: ${emailData.phone}<br>` +
                `Email: ${emailData.email}<br>`;

              if (emailData.parkingLat && emailData.parkingLng) {
                message += `Link to area: ${this.environmentalMediaService.getClientBaseURL()}rental-location-map/admin?latitude=${
                  emailData.parkingLat
                }&longitude=${emailData.parkingLng}&zoom=12`;
                emailData.areaLink = `${this.environmentalMediaService.getClientBaseURL()}rental-location-map/admin?latitude=${
                  emailData.parkingLat
                }&longitude=${emailData.parkingLng}&zoom=12`;
              }

              this.abandonedBuyflowDAO
                .createFromEmailData(emailData)
                .subscribe(() => {});

              this.authService
                .sendMessageToRequestsEmail(subject, message)
                .subscribe((res) => {
                  canLeave.next(response);
                });
            } else {
              canLeave.next(response);
            }
          } else {
            canLeave.next(response);
          }
        }
      });
      return canLeave;
    }
  }
}

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}
